<template>
  <div class="report-view task-time-sheet-report">
    <div
      v-show="exportLoader"
      class="report-loader-screen"
    >
      <div class="d-flex align-items-center justify-content-center h-100 overdlow-sheet">
        <img
          src="../../../public/loader.gif"
          alt=""
        >
      </div>
    </div>

    <div class="viewEdit ttrInfo">

      <!-- Header -->
      <b-card class="d-flex">
        <div class="calendar justify-content-between mt-0">
          <p class="task-timesheet">
            ACL Summary Log Report
          </p>
          <div id="date-select" class="d-flex justify-content-center align-items-center mr-0 calender">
            <VueDatePicker :start="startDate" :end="endDate" :active-btn="activeBtn" @date="updateDate" />
            <Help v-show="$store.state.app.userManualList" code="ACLSLR" />
          </div>
        </div>
      </b-card>

      <!-- Filters -->
      <div class="card-filter-section mt-0">
        <b-row>
          <b-col cols="8" lg="8" class="d-block d-lg-flex align-items-center justify-content-start flex-wrap">
            <button class="back-button btn btn-secondary mr-2" @click="back()">
              <feather-icon icon="ArrowLeftIcon" width="18" height="18" />
              <span>Back</span>
            </button>
            <p class="filter-title">
              Filters:
            </p>
            <div class="">
              <custom-dropdown
                v-model="is_active"
                :options="isActiveList"
                :search-box="false"
                :hide-close="true"
                label="Active"
                icon="EditIcon"
              />
            </div>
            <div>
              <custom-dropdown
                v-model="searchUser"
                :options="filterUserOptions"
                multiple
                label="Members"
                icon="EditIcon"
              />
            </div>
            <div>
              <custom-dropdown
                v-model="attendanceStatus"
                :options="attendanceStatusList"
                multiple
                label="Status"
                icon="EditIcon"
              />
            </div>
            <option-drop-down v-model="perPage" />
          </b-col>
          <b-col cols="4" lg="4" class="d-flex justify-content-end">
            <b-dropdown id="dropdown-right" right text="Export"
              class="custom-drop-timesheet-report filterRedesign side-bar-clear mr-1">
              <template #button-content>
                <div class="d-flex align-items-center">
                  <span class="mr-25 fw-600">Export</span>
                  <feather-icon icon="ChevronDownIcon" width="18" height="18" />
                </div>
              </template>
              <b-dropdown-item @click="confirmationFunction('PDF')">
                PDF
              </b-dropdown-item>
              <b-dropdown-item @click="confirmationFunction('XLSX')">
                XLSX
              </b-dropdown-item>
            </b-dropdown>
            <button class="apply-filter filterRedesign mr-1" @click="applyFilter()">
              Apply Filter
            </button>
            <button class="apply-filter-clear filterRedesign mr-1" @click="clearFilter()">
              Clear
            </button>
          </b-col>
        </b-row>
      </div>

      <!-- Table -->
      <div class="report-task-section">
        <list-loader v-if="loader && reports.length == 0" :fields="tableFields" />

        <div v-else-if="reports.length">
          <div class="emp-list time-sheet-list tableDesigns">
            <div class="scrollable-element" style="overflow-x: auto; width: 100%;">
              <b-table
              :items="reports"
              :fields="tableFields"
              :tbody-tr-class="rowClass"
              :tbody-tr-attr="rowStyle"
              show-empty
              class="emp-list-data emp-list-report time-sheet-report"
            >
              <!-- Emp ID header with legend popover -->
              <template #head(employee_id)>
                <div class="d-flex align-items-center">
                  <span>EMP ID</span>
                  <span id="acl-legend-icon" class="acl-legend-icon ml-25">
                    <feather-icon icon="InfoIcon" size="18" />
                  </span>
                  <b-popover
                    target="acl-legend-icon"
                    triggers="hover"
                    placement="right"
                    custom-class="acl-legend-popover"
                  >
                    <div class="acl-legend-pop-item">
                      <span class="acl-legend-dot dot-late" />
                      <span>Late Arrival</span>
                    </div>
                    <div class="acl-legend-pop-item">
                      <span class="acl-legend-dot dot-wfh" />
                      <span>Work From Home</span>
                    </div>
                    <div class="acl-legend-pop-item">
                      <span class="acl-legend-dot dot-leave" />
                      <span>On Leave</span>
                    </div>
                  </b-popover>
                </div>
              </template>

              <!-- Emp ID -->
              <template #cell(employee_id)="data">
                <div>
                  <p v-if="data.item.employee_id" class="date">
                    {{ data.item.employee_id }}
                  </p>
                  <span v-else>-</span>
                </div>
              </template>

              <!-- Employee Name with avatar + status icons -->
              <template #cell(employee_name)="data">
                <div class="d-flex align-items-center new-time-report">
                  <b-avatar
                    v-if="data.item.user && data.item.user.picture"
                    size="30"
                    :src="data.item.user.picture"
                  />
                  <b-avatar
                    v-else-if="data.item.employee_name"
                    size="30"
                    :text="data.item.employee_name.split(' ')[0] | avatarText"
                    style="background-color: #f97753"
                  />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.employee_name || '-' }}
                    </p>
                  </div>
                </div>
              </template>

              <!-- Date -->
              <template #cell(date)="data">
                <div>
                  <p v-if="data.item.date" class="date">
                    {{ data.item.date | timeDayFormat }}
                  </p>
                  <span v-else>-</span>
                </div>
              </template>

              <!-- First In -->
              <template #cell(first_in)="data">
                <div>
                  <span v-if="data.item.first_in" class="time-badge time-badge-in">
                    {{ data.item.first_in | fullTimeFormat }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </div>
              </template>

              <!-- Last Out -->
              <template #cell(last_out)="data">
                <div>
                  <span v-if="data.item.last_out" class="time-badge time-badge-out">
                    {{ data.item.last_out | fullTimeFormat }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </div>
              </template>

              <!-- Total Time In (minutes → HH:mm) -->
              <template #cell(total_time_in)="data">
                <div class="d-flex align-items-center">
                  <span class="duration-badge">
                    {{ (data.item.total_time_in * 60) | secondsToTime }}
                  </span>
                  <small
                    v-if="(data.item.total_time_in && data.item.track_total_time_in !== undefined && data.item.total_time_in > data.item.track_total_time_in)"
                    class="text-success ml-1 fw-bold time-badge"
                    style="white-space: nowrap; font-size: 0.75rem;"
                  >
                    {{ formatExtraTime(data.item.total_time_in - data.item.track_total_time_in) }}
                  </small>
                </div>
              </template>

              <!-- Total Time Out (minutes → HH:mm) -->
              <template #cell(total_time_out)="data">
                <div>
                  <span class="duration-badge duration-badge-out">
                    {{ (data.item.total_time_out * 60) | secondsToTime }}
                  </span>
                </div>
              </template>

              <!-- Track First In -->
              <template #cell(track_first_in)="data">
                <div>
                  <span v-if="data.item.track_first_in" class="time-badge time-badge-in">
                    {{ data.item.track_first_in | fullTimeFormat }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </div>
              </template>

              <!-- Track Last Out -->
              <template #cell(track_last_out)="data">
                <div>
                  <span v-if="data.item.track_last_out" class="time-badge time-badge-out">
                    {{ data.item.track_last_out | fullTimeFormat }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </div>
              </template>

              <!-- Track Total Time In (minutes → HH:mm) -->
              <template #cell(track_total_time_in)="data">
                <div>
                  <span class="duration-badge">
                    {{ (data.item.track_total_time_in * 60) | secondsToTime }}
                  </span>
                </div>
              </template>

              <!-- Track Total Time Out (minutes → HH:mm) -->
              <template #cell(track_total_time_out)="data">
                <div>
                  <span class="duration-badge duration-badge-out">
                    {{ (data.item.track_total_time_out * 60) | secondsToTime }}
                  </span>
                </div>
              </template>

              <!-- Managed By -->
              <template #cell(manage_by_user)="data">
                <div v-if="data.item.manage_by_user" class="d-flex align-items-center new-time-report">
                  <b-avatar
                    v-if="data.item.manage_by_user.picture"
                    size="30"
                    :src="data.item.manage_by_user.picture"
                  />
                  <b-avatar
                    v-else-if="data.item.manage_by_user.full_name"
                    size="30"
                    :text="data.item.manage_by_user.full_name.split(' ')[0] | avatarText"
                    style="background-color: #f97753"
                  />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.manage_by_user.full_name || '-' }}
                    </p>
                  </div>
                </div>
                <span v-else class="text-muted">-</span>
              </template>

              <!-- Reporting To -->
              <template #cell(reporting_to_user)="data">
                <div v-if="data.item.reporting_to_user" class="d-flex align-items-center new-time-report">
                  <b-avatar
                    v-if="data.item.reporting_to_user.picture"
                    size="30"
                    :src="data.item.reporting_to_user.picture"
                  />
                  <b-avatar
                    v-else-if="data.item.reporting_to_user.full_name"
                    size="30"
                    :text="data.item.reporting_to_user.full_name.split(' ')[0] | avatarText"
                    style="background-color: #f97753"
                  />
                  <div class="emp-detail">
                    <p class="emp-name">
                      {{ data.item.reporting_to_user.full_name || '-' }}
                    </p>
                  </div>
                </div>
                <span v-else class="text-muted">-</span>
              </template>

              <!-- Remarks -->
              <template #cell(remarks)="data">
                <div>
                  <span v-if="data.item.remarks">
                    {{ data.item.remarks }}
                  </span>
                  <span v-else class="text-muted">-</span>
                </div>
              </template>
            
              <template #cell(action)="data">
                <div class="boardDropdown mr-75 text-right">
                  <b-dropdown
                    toggle-class="text-decoration-none"
                    variant="link"
                    boundary="window"
                    menu-class="white-bg-menu"
                    no-caret
                  >
                    <template v-slot:button-content>
                      <button class="edit-del-button">
                      <feather-icon
                        icon="MoreHorizontalIcon"
                        size="21"
                        class="align-left edit-data-delete"
                      />
                      </button>
                    </template>
                    <b-dropdown-item
                      v-if="!(data.item.user && data.item.user.is_system_user)"
                      class="edit-delete-item"
                      @click="navigateToReport('clockInOut', data.item)"
                    >
                      <span class="edit-data">Clock In/Out</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="edit-delete-item"
                      @click="navigateToReport('aclAccessLogReport', data.item)"
                    >
                      <span class="edit-data">ACL Logs Report</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="edit-delete-item"
                      @click="navigateToReport('aclAttendanceAbnormalityReport', data.item)"
                    >
                      <span class="edit-data">ACL Abnormality</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
            </div>

            <Pagination
              v-if="totalCount > 0"
              :current-page="currentPage"
              :per-page="perPage"
              :total-count="totalCount"
              class="report-pagination"
              @currentPage="currentPage = $event"
            />
          </div>
        </div>

        <div v-else class="w-100">
          <img src="@/assets/images/nodatafound/nodata.svg" alt="no-data" class="no-data-img">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import AclSummaryReportMixin from '../../mixin/report/AclSummaryLogReport/index'
import ListLoader from '@/components/loaders/table-loading.vue'
import customDropdown from '@/components/dropdown/customDropdown.vue'
import VueDatePicker from '../../views/TaskSummary/calender.vue'

export default {
  name: 'AclSummaryReport',
  components: {
    ListLoader,
    customDropdown,
    VueDatePicker,
  },
  mixins: [AclSummaryReportMixin],
  methods: {
    navigateToReport(routeName, item) {
      const formattedDate = moment(item.date).format('YYYY-MM-DD')
      const userId = item.user_id || (item.user ? item.user.id : '')

      if (routeName === 'clockInOut') {
        this.$router.push({ name: routeName, query: { userId: userId, date: formattedDate } })
      } else if (routeName === 'aclAccessLogReport') {
        this.$router.push({ name: routeName, query: { searchUser: item.employee_id, startDate: formattedDate, endDate: formattedDate } })
      } else {
        this.$router.push({ name: routeName, query: { searchUser: userId, startDate: formattedDate, endDate: formattedDate } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/component-css/approvals.css";
@import "../../assets/scss/component-css/report.css";
@import "../../assets/scss/variables/_variables.scss";
@import "../../assets/scss/component-css/clockTimesheetReport.scss";
@import "../../assets/scss/component-css/aclSummaryReport.scss";

.boardDropdown .edit-del-button {
  border: transparent;
  padding: 4px;
  border-radius: 5px;
  color: #333333;
  cursor: pointer;
  background-color: #f1f1f1;

  &:hover {
    background-color: $primary-color;
    color: $white;
  }
}

.dropdown-menu {
  border-radius: 0.358rem;
  transform: scale(1, 0);
  box-shadow: 0 5px 25px rgb(34 41 47 / 10%) !important;
  background-color: #fff !important;
  left: 0px !important;
}
</style>

<style>
.white-bg-menu {
  background-color: #ffffff !important;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1) !important;
  border: 1px solid #ebe9f1 !important;
}
</style>
